import ICUNav from "../../pages/Dashboard/ICU/ICUNav";
import ICUDashboard from "../../pages/Dashboard/ICU/ICUDashboard";
import NewAdmission from "../../pages/Dashboard/ICU/Admissions/NewAdmission";
import AdmissionsList from "../../pages/Dashboard/ICU/Admissions/AdmissionsList";
import AdmissionView from "../../pages/Dashboard/ICU/Admissions/AdmissionView";
import RoundsDashboard from "../../pages/Dashboard/ICU/Rounds/RoundsDashboard";
import NewRound from "../../pages/Dashboard/ICU/Rounds/NewRound";
import RoundView from "../../pages/Dashboard/ICU/Rounds/RoundView";
// import RoundsList from "../../pages/Dashboard/ICU/Rounds/RoundsList";

const ICURoutes = {
  path: "/icu",
  element: <ICUNav />,
  children: [
    { path: "/icu", element: <ICUDashboard /> },
    { path: "/icu/admissions", element: <AdmissionsList /> },
    { path: "/icu/admissions/new", element: <NewAdmission /> },
    { path: "/icu/admissions/:id", element: <AdmissionView /> },
    { path: "/icu/rounds", element: <RoundsDashboard /> },
    { path: "/icu/rounds/new", element: <NewRound /> },
    { path: "/icu/rounds/:id", element: <RoundView /> },
    // { path: "/icu/rounds/list", element: <RoundsList /> },
  ],
};

export default ICURoutes;
